import React, { Component } from 'react'
import '../OnlineHelpPage.css'
import ProductSearch_001 from './img/ProductSearch_001.png'
import ProductSearch_002 from './img/ProductSearch_002.png'
import ProductSearch_003 from './img/ProductSearch_003.png'
import ProductSearch_004 from './img/ProductSearch_004.png'

export default class ProductSearch extends Component {
  render() {
    return (
      <div className="main-window">
        <div className="main-window-title">球上产品检索</div>
        <img src={ProductSearch_001} className="main-window-img"></img>
        <img src={ProductSearch_002} className="main-window-img"></img>
        <img src={ProductSearch_003} className="main-window-img"></img>
        <img src={ProductSearch_004} className="main-window-img"></img>
      </div>
    )
  }
}
